import React from 'react';

interface BrandLogoProps {
    className?: string;
    onClick?: () => void;
    /** 'light' = white/light logo for dark backgrounds (Navbar default)
     *  'dark'  = colored logo for light backgrounds (Footer) */
    variant?: 'light' | 'dark';
}

export default function BrandLogo({ className = '', onClick, variant = 'light' }: BrandLogoProps) {
    const logoSrc = variant === 'dark' ? '/assets/logo-dark.png' : '/assets/logo-new.png';

    return (
        <div
            className={`flex items-center gap-2 cursor-pointer group ${className}`}
            onClick={onClick}
        >
            <img
                src={logoSrc}
                alt="Minutes AI Logo"
                className="w-9 h-9 object-contain transition-transform group-hover:scale-105"
            />
            {/* Stunning SVG specific for 'Minutes' */}
            <svg
                viewBox="0 0 120 40"
                className="w-[100px] h-[32px] text-brand-900 drop-shadow-sm translate-y-[2px]"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <text
                    x="50%"
                    y="55%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    style={{
                        fontFamily: "'Nunito', 'Inter', sans-serif",
                        fontWeight: 900,
                        fontSize: '26px',
                        letterSpacing: '0.02em'
                    }}
                >
                    MINUTES
                </text>
            </svg>
        </div>
    );
}
